<template>
  <header>
    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="container header_container">
        <div class="logo">
          <router-link to="/" class="navbar-brand"><img :src="require('../../assets/images/logo.png')" alt="GamesBliss" /></router-link>
        </div>
        <div class="login navbar-menu" v-if="!isAuth">
          <ul class="navbar-nav">
            <li><router-link to="/signin"><span><font-awesome-icon :icon="['fas', 'sign-in-alt']" /></span></router-link></li>
          </ul>
        </div>
        <div v-if="isAuth" class="navbar-menu">
            <ul class="navbar-nav">
              <li><router-link to="/dashboard">Dashboard</router-link></li>
              <li><span @click="logoutUser"><font-awesome-icon :icon="['fas', 'sign-out-alt']" /></span></li>
            </ul>
        </div>
      </div>    
    </nav>
    
  </header>
</template>

<script>
export default {
  computed:{
    isAuth(){
      return this.$store.getters['admin/isAuth'];
    }
  },
  methods:{
    logoutUser(){
      this.$store.commit('admin/logoutUser');
    }
  }
};
</script>